import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import LoginPage from './LoginPage';
import { doAuthentication, savePassword, saveUsername, adminPortal, designerPortal } from '../../actions/userAction';
import { handleCloseAlert } from 'src/actions/errorAction';
import { clearSession } from 'src/actions/aunthenticateAction';

export const mapStateToProps = (state: AppState) => {
    return {
        btnElement: 'Sign-in to Troubleshoot',
        btnType: 'signin',
        errorMessage: state.errorState.errorMessage,
        errorBar: state.errorState.errorBar,
        successMessage: state.errorState.successMessage,
        successBar: state.errorState.successBar,

        username: state.user.username,
        password: state.user.password
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onSubmit: () => {
            // dispatch(fetchCurrentUser);
            dispatch(doAuthentication);
        },
        saveUserName: (username: string) => {
            dispatch(saveUsername(username));
        },
        savePassword: (password: string) => {
            dispatch(savePassword(password));
        },
        goAdminPortal: () => {
            dispatch(adminPortal);
        },
        goDesignerPortal: () => {
            dispatch(designerPortal);
        },
        handleClose: () => {
            dispatch(handleCloseAlert);
        },
        onComponentDidMount: (url: string) => {
            dispatch(clearSession);
        }
    };
};

const LoginPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(LoginPage);

export default LoginPageContainer;



// WEBPACK FOOTER //
// ./src/components/login/LoginContainer.tsx